module.exports = __webpack_public_path__ + "img/logo-lueneburg-large.49ceaac9.png";